import React, { useState } from "react";
import { useBranding } from "@/context/BrandingContext";
import { Sun, Moon, Sparkles } from "lucide-react";

const MODES = {
  light: { canvas: "#F1F3F9", surface: "#FFFFFF", ink: "#0A1029", ink3: "#5A6284", border: "rgba(43,78,255,0.16)" },
  dark: { canvas: "#090C18", surface: "#101527", ink: "#EDF1FB", ink3: "#8A94B8", border: "rgba(108,135,255,0.20)" },
};

export function SharePreview({ dashboardName }) {
  const { branding } = useBranding();
  const tenantDefault = branding.theme === "dark" ? "dark" : "light";
  const [mode, setMode] = useState(tenantDefault);
  const m = MODES[mode];
  const primary = branding.primary_color || "#2B4EFF";
  const accent = branding.accent_color || "#FF6B35";
  return (
    <div data-testid="share-branding-preview" className="mt-3">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-medium text-[color:var(--ink-2)]">How viewers will see it</span>
        <div className="flex gap-1">
          {["light", "dark"].map((k) => (
            <button key={k} data-testid={`share-preview-${k}`} onClick={() => setMode(k)}
              className={`flex items-center gap-1 text-[11px] px-2 py-1 rounded-lg border transition-colors ${mode === k ? "bg-[color:var(--brand-ocean)] text-white border-transparent" : "text-[color:var(--ink-3)] border-[color:var(--glass-border)]"}`}>
              {k === "light" ? <Sun className="w-3 h-3" /> : <Moon className="w-3 h-3" />}
              {k === "light" ? "Light" : "Dark"}{tenantDefault === k ? " · default" : ""}
            </button>
          ))}
        </div>
      </div>
      <div className="rounded-xl overflow-hidden border" style={{ borderColor: m.border, background: m.canvas }}>
        <div className="flex items-center justify-between px-3 py-2" style={{ background: m.surface, borderBottom: `1px solid ${m.border}` }}>
          <span className="text-xs font-semibold truncate" style={{ color: m.ink }}>{dashboardName || "Dashboard"}</span>
          <span className="flex items-center gap-1 text-[10px]" style={{ color: m.ink3 }}>
            {branding.logo_url ? <img src={branding.logo_url} alt="" className="w-3.5 h-3.5 rounded object-cover" /> : <Sparkles className="w-3 h-3" style={{ color: primary }} />}
            {branding.app_name || "Eazy Analytics"}
          </span>
        </div>
        <div className="p-3 grid grid-cols-3 gap-2">
          {[0, 1, 2].map((i) => (
            <div key={i} className="rounded-lg p-2" style={{ background: m.surface, border: `1px solid ${m.border}` }}>
              <div className="h-1.5 rounded-full mb-2" style={{ width: "60%", background: i === 1 ? accent : primary, opacity: 0.9 }} />
              <div className="flex items-end gap-1 h-8">
                {[40, 70, 55, 90, 65].map((h, j) => (
                  <div key={j} className="flex-1 rounded-sm" style={{ height: `${h}%`, background: j % 2 ? accent : primary, opacity: mode === "dark" ? 0.95 : 0.85 }} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="text-[11px] text-[color:var(--ink-3)] mt-1.5">Public viewers get your tenant's branding: colors, logo, name and the default theme set in Admin → Branding.</p>
    </div>
  );
}
